import React, { useEffect } from "react";
import { Tooltip, PieChart, Pie, Cell, Legend, ResponsiveContainer } from "recharts";
import { washDashboardStyles } from "../WashDashboardStyles";
import { useSelector } from "react-redux";
import { groupBy, _ } from "lodash";
import { IconBasicWash } from "icons/mechanicals";
import { IconDetailing } from "icons";

const SlaChartCard = ({ vehiclesReadiness }) => {

    // const [readinessPercentage, setReadinessPercentage] = React.useState(0);

    const classes = washDashboardStyles();
    const { filters } = useSelector(state => state.dashboardState);

    // useEffect(() => {

    let readinessWithinSLAPercentage = 0, numOfClients = 0, readinessByClientFiltered = [];
    let readinessWithSLAFiltered = vehiclesReadiness;
    // vehiclesReadiness?.filter(r => r.underSlaInLastCycle != null &&
    //     (!filters?.lotId?.length || filters?.lotId?.includes(r.lotId)) &&
    //     (!filters?.clientId || filters?.clientId == r.clientId));

    if (readinessWithSLAFiltered?.length > 0) {

        readinessByClientFiltered = groupBy(readinessWithSLAFiltered, readiness => readiness.clientId);
        readinessWithinSLAPercentage = readinessWithSLAFiltered?.filter(a => a.underSlaInLastCycle == true)?.length;
        // Object.keys(readinessByClientFiltered).forEach(client => {
        //     const readinessWithinSLA = readinessByClientFiltered[client].filter(r => r.underSlaInLastCycle == true);
        //     readinessWithinSLAPercentage += ((readinessWithinSLA?.length / (readinessByClientFiltered[client]?.length)) * 100);
        //     numOfClients++;
        // });
    }

    readinessWithinSLAPercentage = Math.round(readinessWithinSLAPercentage / readinessWithSLAFiltered?.length * 100);
    //setReadinessPercentage(readinessWithinSLAPercentage);
    // }, [vehiclesReadiness, filters]);

    const SLAData = [
        { name: "Within SLA", value: readinessWithinSLAPercentage },
        { name: "Above SLA", value: 100 - readinessWithinSLAPercentage },
    ];

    const COLORS = ['#b6ed7b', '#db6f85'];

    const renderColorfulLegendText = (value) => {
        return (
            <span style={{ color: "#596579", fontWeight: 500, padding: "10px" }}>
                {value}
            </span>
        );
    };

    const CustomTooltip = ({ payload }) => {
        return (
            <div>
                <div className={classes.tooltip} >
                    <p>
                        <b>{payload?.[0]?.payload?.name} </b>
                        {payload?.[0]?.payload?.value}%
                    </p>
                </div>
            </div>
        );
    };

    return (
        <ResponsiveContainer>
            <PieChart>
                <Pie
                    data={SLAData}
                    dataKey="value" nameKey="name"
                    cx={"50%"} cy={"50%"}
                    innerRadius={70} outerRadius={90}
                    paddingAngle={0.5} >
                    {SLAData.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <foreignObject x="50%" y="50%" width="40" height="40" transform="translate(-20,-30)">
                    <div className={classes.washIcon}>
                        <IconDetailing />
                    </div>
                </foreignObject>
                <Legend
                    iconType="circle"
                    iconSize={10}
                />
                <Tooltip content={<CustomTooltip />} />
            </PieChart>
        </ResponsiveContainer>
    )
}

export default SlaChartCard;